import { useContext } from 'react';

import { DepartmentContext } from './context';

import type { DepartmentContextValue } from './types';

/**
 * Department コンテキストの値を取得するためのカスタムフック
 */
export const useDepartment = (): DepartmentContextValue => {
  const context = useContext(DepartmentContext);
  if (context === null) {
    throw new Error('useDepartment must be used within a DepartmentProvider');
  }
  return context;
};
